import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'material-ui/Icon';

const CONFIG = require('../../../config.json');

function extractHostname(url) {
    let hostname;
    if (url.indexOf("://") > -1) {
        hostname = url.split('/')[2];
    } else {
        hostname = url.split('/')[0];
    }
    hostname = hostname.split(':')[0];
    hostname = hostname.split('?')[0];
    return hostname;
}

const EdgeDetail = ({ handleCloseDetailClick, edge, nodes }) => {
  const output = {};
  if (handleCloseDetailClick) {
    output.button = (
      <Icon color="action" onClick={handleCloseDetailClick} className="close-icon">close</Icon>
    );
  }

  let from_node = {};
  for (let node of nodes) {
    if (node.id === edge.from)
        from_node = node;
  }

  let to_node = {};
  for (let node of nodes) {
    if (node.id === edge.to)
        to_node = node;
  }

  output.references = [];
  let references = [];
  if( edge.reference ) {
      references.push(edge.reference);
  }
  if( edge.references ) {
    references.push(edge.references);
  }
  let index = 0;
  let key = new Date().getTime();
  for (let reference of references) {
    key += index;
    output.references.push(
        <div key={key}>
            <a className="reference" href={reference} target="_blank">{extractHostname(reference)}</a>
        </div>
    );
    index++;
  }

  const page = CONFIG.reportPageOffset + edge.page;
  output.report = [];
  if ( edge.page ) {
      let key = new Date().getTime();
      output.report.push(
          <a key={key} href={CONFIG.reportPDFLink+'#page='+page} target="_blank">View full report: page {edge.page}</a>
      );
  }

  return (
    <div className="edge_detail">
      <div className="detail">
        <div className="info">
            <div className="lead"><h3>FROM</h3></div>
            <div className="name">
                <h3>{from_node.label}</h3>
            </div>
        </div>
        <div className="photo">
            <img src={from_node.image} alt='photo' width='100' height='100' />
        </div>
        {output.button}
        <div className="connection-info">
            <div className="name"><h3>Connection: {edge.type}</h3></div>
        </div>
        <div className="info">
            <div className="lead"><h3>To</h3></div>
            <div className="name">
                <h3>{to_node.label}</h3>
            </div>
        </div>
        <div className="photo">
            <img src={to_node.image} alt='photo' width='100' height='100' />
        </div>
      </div>
      <div className="description">
        {edge.description}
      </div>
      <div className="report">
        {output.report}
      </div>
      <div className="references">
        {output.references}
      </div>
    </div>
  );
};

EdgeDetail.propTypes = {
  edge: PropTypes.object,
  nodes: PropTypes.array,
  handleCloseDetailClick: PropTypes.func,
};

export default EdgeDetail;



// WEBPACK FOOTER //
// ./scripts/components/EdgeDetail.jsx